import { executeRequest, JFSRequest } from '@jfs/network'
import { RootStore } from '../data/store'
import { isSuccessResponse } from './../utils/index'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  const data = isSuccessResponse(response)
  return data?.data
}

const fetchGroupByRiskTnxApi = (req: any, abortController?: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.groupByRiskTnxApi),
    method: 'POST',
    cache: false,
    config: sitConfig(RootStore.session.getTokens, abortController),
    headers: getHeaders(),
    body: req,
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { fetchGroupByRiskTnxApi }
